// The one rule set for "does this field go to the machine translation": used by the field
// list's run (TranslationFields) and by the size chart's "update and translate" run, so a rule
// added to one applies to the other. The size chart once sent an image URL because its run had
// its own copy of the rule.

// A run is a selection of field kinds: untranslated fields, translations whose original changed
// (the section's outdated flag), existing translations. The string modes are shorthands
export const modeSelection = (mode) => {
  if(typeof mode !== 'string') return mode;
  switch(mode) {
    case 'all': return { empty: true, outdated: false, filled: true };
    case 'filled': return { empty: false, outdated: false, filled: true };
    case 'outdated': return { empty: true, outdated: true, filled: false };
    default: return { empty: true, outdated: false, filled: false };
  }
};

// Fields left out of a run by default - the merchant may still tick them in the dialog's field
// table: the handle is the URL slug, and the product type mostly organises the catalogue, so both
// wait for an explicit choice. A section's flag (numbers, sizes: machineTranslate false) is NOT
// one of them: it steers progress and placeholders only; which strings the machine translation
// leaves as they are is the translation service's call (word count with skip_details)
export const DEFAULT_SKIP_REASONS = { handle: 'handle', product_type: 'productType' };
export const skipReasonOf = (field) => DEFAULT_SKIP_REASONS[field.id] || null;
export const isSkippedByDefault = (field) => skipReasonOf(field) !== null;

// Can this field be machine-translated at all? Images are URLs (the service would translate the
// file name), an empty source has nothing to translate, SEO fields Shopify has not customized
// inherit from the content so a translation has no effect. With respectFlag the default skips
// above count as well
// A Shopify id as the source (video and file references in metaobjects and metafields; image ones
// are image rows already) is never a translation. Such a field is no candidate in any run - left in,
// it was counted in one run and skipped by the service in the other, so the two runs told different
// stories about the same item - but the dialog's table still lists it, greyed with the reason, so
// the merchant sees why a field of the item is not part of the run
export const referenceReasonOf = (field) =>
  (typeof field.source === 'string' && /^gid:\/\/shopify\//.test(field.source.trim())) ? 'reference' : null;

// does the field's translation state match the run's selection, regardless of translatability
export const matchesSelection = (field, mode) => {
  const sel = modeSelection(mode);
  const filled = field.target !== '' && field.target !== null && field.target !== undefined;
  return (sel.empty && !filled) || (sel.filled && filled) || (sel.outdated && filled && field.outdated === true);
};

export const isMachineTranslatable = (field, { respectFlag = true } = {}) => {
  if(field.type === 'image') return false;
  if(!field.source || (typeof field.source === 'string' && field.source.trim() === '')) return false;
  if(referenceReasonOf(field) !== null) return false;
  if(field.customized === false) return false;
  if(respectFlag && isSkippedByDefault(field)) return false;
  return true;
};

// Does the run with this selection take the field? The section flag is left to the caller: the
// field list treats it as a default the dialog may override, the size chart run as final
export const wantsMachineTranslation = (field, mode) => {
  if(!isMachineTranslatable(field, { respectFlag: false })) return false;
  return matchesSelection(field, mode);
};
